const UPSELL_MODAL_OPEN_BODY_CLASS = 'upsell-modal-open'

const DEFAULT_MAX_WAIT_MS = 8000

const DEFAULT_POLL_INTERVAL_MS = 500

/**
 * Waits until no upsell modal is open on the page, or until maxWaitMs elapses.
 * Keeps the feedback prompt from stacking on top of PostTestUpsell.
 */
export const waitForClearModalSlot = ({
  maxWaitMs = DEFAULT_MAX_WAIT_MS,
  pollIntervalMs = DEFAULT_POLL_INTERVAL_MS,
}: {
  maxWaitMs?: number
  pollIntervalMs?: number
} = {}): Promise<void> => {
  if (typeof document === 'undefined') {
    return Promise.resolve()
  }

  return new Promise((resolve) => {
    const startedAt = Date.now()

    const check = () => {
      const isSlotClear = !document.body.classList.contains(UPSELL_MODAL_OPEN_BODY_CLASS)
      const hasTimedOut = Date.now() - startedAt >= maxWaitMs

      if (isSlotClear || hasTimedOut) {
        resolve()
        return
      }

      setTimeout(check, pollIntervalMs)
    }

    check()
  })
}
